/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface AuthCustomToken$Params {
}

export function authCustomToken(http: HttpClient, rootUrl: string, params?: AuthCustomToken$Params, context?: HttpContext): Observable<StrictHttpResponse<{

/**
 * Custom token for authentication
 */
'customToken'?: string;
}>> {
  const rb = new RequestBuilder(rootUrl, authCustomToken.PATH, 'post');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      
      /**
       * Custom token for authentication
       */
      'customToken'?: string;
      }>;
    })
  );
}

authCustomToken.PATH = '/auth/customToken';
